"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const colors_1 = require("../../assets/jss/colors");
const styles = (theme) => (0, styles_1.createStyles)({
    tabs: {
        display: 'flex'
    },
    tabButton: Object.assign(Object.assign({}, theme.typography.subtitle2), { color: 'rgba(0, 0, 0, 0.64)', borderColor: theme.palette.text.secondary, backgroundColor: theme.palette.background.default, height: 38, padding: theme.spacing(), marginRight: theme.spacing(), '&.Mui-focusVisible': {
            boxShadow: `0 0 0px 2px white, 0 0 0 6px ${colors_1.default.themeColors.boxShadowColor.hex()}  !important`,
            outline: `${colors_1.default.themeColors.black.hex()} !important`,
            outlineOffset: '2px !important',
            transition: 'background-color 0.3s ease, outline 0.3s ease !important'
        } }),
    selected: {
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        boxShadow: theme.shadows[6],
        '&:hover, &:active, &:focus': {
            backgroundColor: theme.palette.primary.main + ' !important'
        }
    },
    icon: {
        color: theme.palette.primary.contrastText,
        right: 5
    },
    customLineHeight: {
        lineHeight: 12,
        overflow: 'hidden'
    },
    input: Object.assign(Object.assign({}, theme.typography.subtitle2), { minWidth: 102, padding: theme.spacing(), paddingRight: 25, backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText, boxShadow: theme.shadows[6], display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 30, '&:focus, &:active': {
            backgroundColor: theme.palette.primary.main + ' !important',
            borderRadius: 30,
            boxShadow: '0 0 0px 2px white, 0 0 0 6px ' + theme.palette.primary.main
        } })
});
exports.default = styles;
//# sourceMappingURL=ChipTabsStyle.js.map